import * as echarts from "echarts";

export default {
    props: {
        groupId: String,
        disableAutoRefresh: {
            type: Boolean,
            default: false
        },
        notMerge: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        options: {
            handler() {
                if (!this.disableAutoRefresh) {
                    this.chart.setOption(this.options, {
                        lazyUpdate: true,
                        notMerge: this.notMerge,
                    });
                }
            },
            deep: true,
        },
    },
    mounted() {
        this.initChart();
        window.addEventListener('resize', this.handle);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handle);
        if (this.chart) {
            this.chart.dispose();
            this.chart = null;
        }
    },

    methods: {
        initChart() {
            this.chart = echarts.init(document.getElementById(this.localChartId));
            this.chart.setOption(this.options);
            if (this.groupId) {
                this.chart.group = this.groupId;
            }
        },
        handle() {
            this.chart.setOption(this.options);
            this.chart.resize()
        },
        setOption(option) {
            this.chart.setOption(option);
        },
        resize() {
            this.chart.resize();
        }
    }
}
